<template>
  <div>
    <statistics-chart
      v-if="chartdata"
      @changeChartTypeDetail="changeChartTypeDetail"
      :chartdata="chartdata"
      :loading="loading"
      :chartTypeDetailProp="selectedChartTypeDetail"
      chartTypeDetailActive
      unStacked
    >
    </statistics-chart>
  </div>
</template>

<script>
import StatisticsChart from "./StatisticsChart.vue";
import RequestApi from "../../modules/requestApi";
import moment from "moment";

export default {
  name: "StatisticsGeneralComparision",

  components: { StatisticsChart },

  props: {
    // массив списка хотспотов из фильтров
    filterParams: {
      type: Array,
      requried: true,
    },
  },

  data: () => ({
    // статус загрузки
    loading: false,
    // данные графика
    chartdata: {
      labels: [],
      datasets: [],
    },
    // тип детализации графика
    selectedChartTypeDetail: "day",
    // форматы дат графика
    format: {
      day: "DD.MM.YYYY",
      month: "MMM YYYY",
      year: "YYYY",
    },
  }),

  computed: {
    // цветовая тема проекта
    themeDark() {
      return this.$store.getters.themeDark;
    },
    // тип временного отрезка для детализация графика
    dateType() {
      return this.filterParams[0].chartTypeDetail;
    },
  },

  watch: {
    // обновление данных при изменениях фильтра
    filterParams(value) {
      if (value) this.changeChartTypeDetail(this.selectedChartTypeDetail);
    },

    // обновление для цвета графика при смене темы
    themeDark() {
      this.changeChartTypeDetail(this.selectedChartTypeDetail);
    },
  },

  mounted() {
    // загружаем список хотспотов
    this.$store.dispatch("hotspotListLoad").then(() => {
      // задается тип детализации
      this.selectedChartTypeDetail = this.filterParams.find(
        (item) => item.chartTypeDetail
      ).chartTypeDetail;

      this.init();
    });
  },

  methods: {
    /**
     * Инициализация данных
     */
    init() {
      this.loading = true;
      this.$emit("isLoading", true);
      if (this.$store.getters.hotspotIsLoaded) {
        this.$emit("setFilter", this.filterParams);
        this.getChartData(this.filterParams);
      }
    },
    //обнуляем данные графика
    initChartData() {
      return {
        labels: [[], []],
        datasets: [
          {
            data: [],
            label: "",
            id: "xAxisFirst",
            backgroundColor: this.$store.getters.themeDark
              ? "#00CB9A"
              : "#235087",
          },
          {
            data: [],
            label: "",
            id: "xAxisSecond",
            backgroundColor: "#005CFF",
          },
        ],
      };
    },

    /**
     * Получение данных из базы
     */
    async getChartData(params) {
      this.chartdata = this.initChartData();
      for (let i = 0; i < params.length; i++) {
        const responseData = await this.statChartData(params[i]);

        //выделяем все даты для графика за выбранный период
        let currentDay = moment(new Date(params[i].range.startDate));
        this.chartdata.labels[i] = [];
        this.chartdata.datasets[i].data = [];
        // ("hour", 23) - временные метки приходят с разными hh:mm, изменяю на конец дня
        while (currentDay <= moment(params[i].range.endDate).set("hour", 23)) {
          this.chartdata.labels[i].push(
            this.conversionToSelectedFormat(currentDay)
          );
          this.chartdata.datasets[i].data.push(0);
          if (this.dateType === "day") {
            currentDay.add(1, "days");
          } else {
            currentDay.add(1, this.dateType).startOf(this.dateType);
          }
        }

        // заполняем массив данными от сервера
        responseData.minDate.map((label) => {
          const labelIndex = this.chartdata.labels[i].indexOf(label);
          this.chartdata.datasets[i].data[labelIndex] =
            responseData.count[labelIndex];
        });
      }

      // если выбран период в неделю - машем бубном и меняем лейблы
      if (this.dateType === "week") {
        this.chartdata.labels.forEach((array, i) =>
          this.$set(
            this.chartdata.labels,
            i,
            array.map((label) => {
              let startDate = moment(label, "DD.MM.YYYY");
              let endDate = moment(new Date(startDate)).add(6, "days");

              if (
                label &&
                startDate.format(this.format.day) ===
                  moment(params[i].range.startDate).format(this.format.day)
              ) {
                endDate = moment(new Date(startDate)).weekday(6);
              }
              if (label && endDate > moment(params[i].range.endDate)) {
                endDate = moment(params[i].range.endDate);
              }
              return label
                ? `${startDate.format(this.format.day)} - ${endDate.format(
                    this.format.day
                  )}`
                : "";
            })
          )
        );
      }
      // дополняем один из массивов лейблов пустыми строками, если необходимо
      const labelsLenghtDiff =
        this.chartdata.labels[1].length - this.chartdata.labels[0].length;
      for (let i = 0; i < Math.abs(labelsLenghtDiff); i++) {
        if (labelsLenghtDiff > 0) {
          this.chartdata.labels[0].push("");
        } else {
          this.chartdata.labels[1].push("");
        }
      }

      this.loading = false;
      this.$emit("isLoading", false);
    },
    /**
     * Менят тип детализации графика и
     * перезапускает отрисовку графика
     */
    changeChartTypeDetail(value) {
      // сохранение значения детализации для перерисовки
      this.selectedChartTypeDetail = value;
      for (let item of this.filterParams) {
        item.chartTypeDetail = value;
      }
      this.init();
    },

    // Получение данных из базы
    statChartData(params) {
      return new Promise((resolve, reject) => {
        RequestApi.statChartData(params)
          .then((data) => {
            resolve({
              count: data.map((item) => item.cnt),
              // переводим лэйблы в нужный формат, получая первую дату нужного отрезка
              minDate: data.map((item) =>
                this.dateType === "week"
                  ? this.conversionToSelectedFormat(
                      moment(item.minDate).weekday(0)
                    )
                  : this.dateType === "month"
                  ? this.conversionToSelectedFormat(
                      moment(item.minDate).month(moment(item.minDate).month())
                    )
                  : this.dateType === "year"
                  ? this.conversionToSelectedFormat(
                      moment(item.minDate).dayOfYear(1)
                    )
                  : this.conversionToSelectedFormat(moment(item.minDate))
              ),
            });
          })
          .catch(reject);
      });
    },
    // перевод даты в выбранный формат
    conversionToSelectedFormat(date) {
      if (this.dateType === "week") {
        return date.format(this.format.day);
      }
      return date.format(this.format[this.dateType]);
    },
  },
};
</script>
